import { addressBookActions } from "./address-book-slice";
import { configuratorActions } from "./configurator-slice";
import config from "./config";
import { getCsrfToken } from './config';

export const fetchAddressBookData = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        config.settings.apiEndpoint + "api/requests/GetDonorAddresses",
        {
          method: "GET",
          credentials: "include",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          },
        }
      );

      if (!response.ok) {
        throw new Error("Could not fetch address book data!");
      }

      const data = await response.json();

      return data;
    };

    try {
      const responseData = await fetchData();
      dispatch(addressBookActions.setInitialState(responseData));
    } catch (error) {
      // dispatch error msg
    }
  };
};

export const sendAddressBookLogin = (credentials) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      let data = {};
      const response = await fetch(
        config.settings.apiEndpoint + "api/requests/SignIn",
        {
          method: "POST",
          credentials: "include",
          body: JSON.stringify(credentials),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          },
        }
      );

      const json = await response.json();

      if (!response.ok) {
        data.isAuthenticated = false;
        data.error = "Your login information was not valid.";
      } else {
        data = json;
        dispatch(configuratorActions.setLoggedInDonor(data));
      }

      // Check if the response includes a new anti-forgery token
      console.log('data:', data);
      if (data.antiForgeryToken) {
        // Update the window.AntiForgeryToken with the new value
        window.AntiForgeryToken = data.antiForgeryToken;
      }

      return data;
    };

    try {
      const responseData = await sendRequest();
      dispatch(addressBookActions.setLoginResult(responseData));
    } catch (error) {
      dispatch(
        addressBookActions.setLoginResult({
          isAuthenticated: false,
          error: "Your login information was not valid."
        })
      );
    }
  };
};

export const sendAddressBookUpdate = (address) => {
  return async (dispatch, getState) => {
    const sendRequest = async () => {
      const state = getState();
      const addressBookState = state.addressBook;
      const configuratorState = state.configurator;
      
      const userId = addressBookState.LoginAttemptResponse?.donorInfo?.id || 
                    configuratorState?.ConfiguratorRequest?.DonorInfo?.Id;
      
      if (!userId) {
        throw new Error('User ID not found');
      }

      const addressWithUserId = {
        ...address,
        UserId: userId
      };

      const response = await fetch(
        config.settings.apiEndpoint + "api/requests/AddOrUpdateAddress",
        {
          method: "POST",
          credentials: "include",
          body: JSON.stringify(addressWithUserId),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          },
        }
      );

      if (!response.ok) {
        return { error: "There was an error saving the address." };
      }

      return await response.json();
    };

    try {
      const responseData = await sendRequest();
      dispatch(fetchAddressBookData());
      dispatch(addressBookActions.setStatusMessage({
        message: 'The address was saved.', 
        error: false, 
        type: 'update'
      }));
    } catch (error) {
      dispatch(
        addressBookActions.setStatusMessage({
          message: 'There was an error saving the address.',
          error: true, 
          type: 'update'
        })
      );
    }
  };
};

export const sendAddressDelete = (address) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      let data = {};
      const response = await fetch(
        config.settings.apiEndpoint + "api/requests/DeleteAddress",
        {
          method: "POST",
          credentials: "include",
          body: JSON.stringify(address),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          },
        }
      );

      const json = await response.json();

      if (!response.ok) {
        data.error = "There was an error deleting the address.";
      } else {
        data = json;
      }

      return data;
    };

    try {
      const responseData = await sendRequest();
      dispatch(fetchAddressBookData());
      dispatch(addressBookActions.setStatusMessage({message: 'The address was deleted.', error: false, type: 'delete'}));
    } catch (error) {
      dispatch(
        addressBookActions.setStatusMessage({
          message: 'There was an error deleting the address.',
          error: true,
          type: 'delete'
        })
      );
    }
  };
};